<template>
  <div class="relative">
    <div class="vx-navbar-wrapper">
      <vs-navbar
        class="vx-navbar navbar-custom"
        :color="navbarColor"
        :class="classObj"
      >
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer mr-1"
          icon="MenuIcon"
          @click.stop="showSidebar"
        ></feather-icon>
        <template v-if="breakpoint != 'md'">
          <div
            class="vx-navbar__starred-pages--more-dropdown"
            v-if="starredPagesMore.length"
          >
            <vs-dropdown vs-custom-content vs-trigger-click>
              <feather-icon
                icon="ChevronDownIcon"
                svgClasses="h-4 w-4"
                class="cursor-pointer p-2"
              ></feather-icon>
              <vs-dropdown-menu>
                <ul class="vx-navbar__starred-pages-more--list">
                  <draggable
                    v-model="starredPagesMore"
                    :group="{ name: 'pinList' }"
                    class="cursor-move"
                  >
                    <li
                      class="starred-page--more flex items-center cursor-pointer"
                      v-for="page in starredPagesMore"
                      :key="page.url"
                      @click="$router.push(page.url)"
                    >
                      <feather-icon
                        svgClasses="h-5 w-5"
                        class="ml-2 mr-1"
                        :icon="page.labelIcon"
                      ></feather-icon>
                      <span class="px-2 pt-2 pb-1">{{ page.label }}</span>
                    </li>
                  </draggable>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>
        <div
          class="theme-container m-0 cursor-pointer"
          :class="isDarkMode ? 'shadow-light' : 'shadow-dark'"
          @click="onDarkMode"
        >
          <img
            v-if="isDarkMode"
            src="@/assets/images/icons/sun-bright.svg"
            alt="ERR"
          />
          <img
            v-else
            src="@/assets/images/icons/moon.svg"
            id="moon"
            alt="ERR"
          />
        </div>
        <vs-spacer></vs-spacer>
        <router-link
          :to="{ path: '/ManagementDashboard' }"
          id="monitorBtn"
          target="_blank"
          v-has-permission="permission302"
        >
          <feather-icon
            icon="TvIcon"
            svgClasses="h-6 w-6"
            class="cursor-pointer p-2"
          ></feather-icon>
          <span class="ttl"> {{ $t("ManagementDashboard") }}</span>
        </router-link>
        <vs-button
          color="success"
          type="gradient"
          icon-pack="feather"
          class="d-inline mx-4"
          @click="onShowSurveyPopup()"
        >
          {{ $t("Survey") }}</vs-button
        >
        <!-- <span class="flex i18n-locale items-center"
          ><img
            class="h-4 w-5 mr-1 ml-1"
            :src="require(`@/assets/images/flags/${$i18n.locale}.png`)"
            :alt="$i18n.locale"
          /><span class="hidden sm:block ml-2">{{
            getCurrentLocaleData.lang
          }}</span></span
        > -->
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
          <vs-dropdown-menu
            class="cart-dropdown vx-navbar-dropdown"
            :class="{ 'dropdown-custom': cartItems.length }"
          >
            <template v-if="cartItems.length">
              <div
                class="notification-header text-center p-5 bg-primary text-white"
              >
                <h3 class="text-white">
                  {{ cartItems.length }} Item<span v-show="cartItems.length > 1"
                    >s</span
                  >
                </h3>
                <p class="opacity-75">In Your Cart</p>
              </div>
              <VuePerfectScrollbar
                ref="mainSidebarPs"
                class="scroll-area--cart-items-dropdowm p-0 mb-10"
                :settings="settings"
              >
                <ul class="bordered-items">
                  <li
                    v-for="item in cartItems"
                    :key="item.objectID"
                    class="vx-row no-gutter cart-item cursor-pointer"
                  >
                    <div
                      class="vx-col w-1/5 item-img-container bg-white flex items-center justify-center"
                    >
                      <img
                        :src="item.image"
                        alt="item"
                        class="cart-dropdown-item-img p-4"
                      />
                    </div>
                    <div
                      class="vx-col w-4/5 pr-4 pl-2 py-4 flex flex-col justify-center"
                    >
                      <span
                        class="font-medium block cart-item-title truncate"
                        >{{ item.name }}</span
                      >
                      <small class="truncate mb-2">{{
                        item.description
                      }}</small>
                      <div class="flex items-center justify-between">
                        <span class="text-sm font-medium"
                          >{{ item.quantity }} <small>x</small> ${{
                            item.price
                          }}</span
                        >
                        <feather-icon
                          icon="XIcon"
                          svgClasses="h-4 w-4 cursor-pointer text-danger"
                          class="hover:text-danger"
                          @click.stop="removeItemFromCart(item)"
                        />
                      </div>
                    </div>
                  </li>
                </ul>
              </VuePerfectScrollbar>
              <div
                class="checkout-footer fixed bottom-0 rounded-b-lg text-primary font-semibold w-full p-2 text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
                @click="$router.push('/apps/eCommerce/checkout')"
              >
                <span class="flex items-center justify-center">
                  <feather-icon
                    icon="ShoppingCartIcon"
                    svgClasses="h-4 w-4"
                  ></feather-icon>
                  <span class="ml-2">Checkout</span>
                </span>
              </div>
            </template>
            <template v-else>
              <p class="p-4">Your Cart Is Empty.</p>
            </template>
          </vs-dropdown-menu>
        </vs-dropdown>
        <div class="the-navbar__user-meta flex items-center">
          <vs-dropdown
            vs-custom-content
            vs-trigger-click
            class="cursor-pointer"
          >
            <div class="con-img ml-3">
              <img
                v-if="activeUserImg.startsWith('http')"
                key="onlineImg"
                :src="activeUserImg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <img
                v-else
                key="localImg"
                :src="require(`@/assets/images/custom/${activeUserImg}`)"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
            </div>
            <vs-dropdown-menu class="vx-navbar-dropdown">
              <ul style="min-width: 9rem">
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/')"
                >
                  <feather-icon icon="ActivityIcon" svgClasses="w-4 h-4" />
                  <span class="mr-2">{{ $t("Dashboard") }}</span>
                </li>
                <!--<li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                    @click="$router.push('/')">
                  <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
                  <span class="mr-2">{{$t('Inbox')}}</span>
                </li>-->
                <!--<li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/todo')">

                  <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Tasks</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/chat')">

                  <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Chat</span>
                </li>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/apps/eCommerce/wish-list')">

                  <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
                  <span class="ml-2">Wish List</span>
                </li>-->
                <vs-divider class="m-1"></vs-divider>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="$router.push('/Profile/Index')"
                >
                  <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                  <span class="mr-2">{{ $t("Profile") }} </span>
                </li>
                <vs-divider class="m-1"></vs-divider>
                <li
                  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                  @click="logout"
                >
                  <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                  <span class="mr-2">{{ $t("Logout") }} </span>
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div
            class="text-right leading-tight hidden sm:flex items-center mt-1"
          >
            <p class="font-semibold">{{ username }}</p>
            <!--<small>مدیر فروش</small>-->
          </div>
        </div>
      </vs-navbar>
    </div>
    <survey-popup :show="isShowSurveyPopup" @finish="onfinish"></survey-popup>
  </div>
</template>
<style scoped>
.theme-container {
  width: 45px;
  height: 45px;
  flex-shrink: 0;
  margin: 0;
  border-radius: 50%;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  transition: 0.5s;
  margin-right: 10px !important;
}

.theme-container:hover {
  opacity: 0.4;
}

.theme-container img {
  max-height: 65%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
}
.theme-container img#moon {
  right: 2px;
}

.shadow-dark {
  background: #000;
}

.shadow-light {
  background: #ffffff;
}
</style>

<script>
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import draggable from "vuedraggable";
import authService from "../../auth/authService";
import SurveyPopup from "../../views/ManagementDashboard/SurveyPopup.vue";
import themeConfig from "@/../themeConfig.js";
import { mapActions } from "vuex";

export default {
  name: "the-navbar",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      permission302: "ButtonManagementDashboard",
      username: "",
      navbarSearchAndPinList: this.$store.state.navbarSearchAndPinList,
      searchQuery: "",
      showFullSearch: false,
      isDarkMode: false,
      isShowSurveyPopup: false,
      unreadNotifications: [
        {
          index: 0,
          title: "New Message",
          msg: "Are your going to meet me tonight?",
          icon: "MessageSquareIcon",
          time: "Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)",
          category: "primary",
        },
        {
          index: 1,
          title: "New Order Recieved",
          msg: "You got new order of goods.",
          icon: "PackageIcon",
          time: "Wed Jan 30 2019 07:45:23 GMT+0000 (GMT)",
          category: "success",
        },
        {
          index: 2,
          title: "Server Limit Reached!",
          msg: "Server have 99% CPU usage.",
          icon: "AlertOctagonIcon",
          time: "Thu Jan 31 2019 07:45:23 GMT+0000 (GMT)",
          category: "danger",
        },
        {
          index: 3,
          title: "New Mail From Peter",
          msg: "Cake sesame snaps cupcake",
          icon: "MailIcon",
          time: "Fri Feb 01 2019 07:45:23 GMT+0000 (GMT)",
          category: "primary",
        },
        {
          index: 4,
          title: "Bruce's Party",
          msg: "Chocolate cake oat cake tiramisu",
          icon: "CalendarIcon",
          time: "Fri Feb 02 2019 07:45:23 GMT+0000 (GMT)",
          category: "warning",
        },
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      autoFocusSearch: false,
      showBookmarkPagesDropdown: false,
    };
  },
  watch: {
    $route() {
      if (this.showBookmarkPagesDropdown)
        this.showBookmarkPagesDropdown = false;
    },
  },
  computed: {
    // HELPER
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    breakpoint() {
      return this.$store.state.breakpoint;
    },

    // NAVBAR STYLE
    classObj() {
      if (this.sidebarWidth == "default") return "navbar-default";
      else if (this.sidebarWidth == "reduced") return "navbar-reduced";
      else if (this.sidebarWidth) return "navbar-full";
    },

    // I18N
    getCurrentLocaleData() {
      const locale = this.$i18n.locale;
      if (locale == "fa") {
        document.querySelector("body").setAttribute("dir", "rtl");
        return { flag: "ir", lang: "Persian" };
      } else if (locale == "en") {
        document.querySelector("body").setAttribute("dir", "ltr");

        return { flag: "us", lang: "English" };
      }
    },

    // BOOKMARK & SEARCH
    data() {
      return this.$store.state.navbarSearchAndPinList;
    },
    starredPages() {
      return this.$store.state.starredPages;
    },
    starredPagesLimited: {
      get() {
        return this.starredPages.slice(0, 10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesLimited", list);
      },
    },
    starredPagesMore: {
      get() {
        return this.starredPages.slice(10);
      },
      set(list) {
        this.$store.dispatch("arrangeStarredPagesMore", list);
      },
    },

    // CART DROPDOWN
    cartItems() {
      return this.$store.state.eCommerce.cartItems.slice().reverse();
    },

    // PROFILE

    activeUserImg() {
      return (
        // JSON.parse(localStorage.getItem("userInfo")).photoURL ||
        this.$store.state.AppActiveUser.img
      );
    },
  },
  mounted() {
    this.user_displayName();
    if (localStorage.getItem("theme")) {
      const localStorageTheme = localStorage.getItem("theme");
      this.toggleClassInBody(localStorageTheme);
      if (localStorageTheme === "dark") {
        this.turnOnDarkMode();
      }
    } else {
      this.toggleClassInBody(themeConfig.theme);
    }
  },
  methods: {
    ...mapActions({
      turnOnDarkMode: "theme/turnOnDarkMode",
      turnOffDarkMode: "theme/turnOffDarkMode",
    }),
    async user_displayName() {
      var userInfo = await authService.getUser();
      this.username = userInfo.profile.nickname
        ? typeof userInfo.profile.nickname == "object"
          ? userInfo.profile.nickname[userInfo.profile.nickname.length - 1]
          : userInfo.profile.nickname
        : "بدون نام";
    },
    toggleClassInBody(className) {
      if (className == "dark") {
        document.body.classList.add("theme-dark");
        this.isDarkMode = true;
      } else {
        if (document.body.className.match("theme-dark"))
          document.body.classList.remove("theme-dark");
      }
    },
    onDarkMode() {
      if (this.isDarkMode) {
        this.isDarkMode = false;
        this.turnOffDarkMode();
        this.toggleClassInBody("light");
        localStorage.setItem("theme", "light");
      } else {
        this.isDarkMode = true;
        this.turnOnDarkMode();
        this.toggleClassInBody("dark");
        localStorage.setItem("theme", "dark");
      }
    },
    onShowSurveyPopup() {
      this.isShowSurveyPopup = true;
    },
    updateLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("locale", locale);
      this.$router.go(this.$router.currentRoute);
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
    },
    selected(item) {
      this.$router.push(item.url);
      this.showFullSearch = false;
    },
    actionClicked(item) {
      this.$store.dispatch("updateStarredPage", {
        index: item.index,
        val: !item.highlightAction,
      });
    },
    showNavbarSearch() {
      this.showFullSearch = true;
    },
    showSearchbar() {
      this.showFullSearch = true;
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? `${seconds} sec ago` : "just now");
      }

      return "Just Now";
    },
    logout() {
      this.$auth.logOut();
      this.$acl.change("admin");
      localStorage.removeItem("userRole");
    },
    outside: function () {
      this.showBookmarkPagesDropdown = false;
    },
    removeItemFromCart(item) {
      this.$store.dispatch("eCommerce/toggleItemInCart", item);
    },
    onfinish() {
      this.isShowSurveyPopup = false;
    },
  },
  directives: {
    "click-outside": {
      bind: function (el, binding) {
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;
        document.addEventListener("click", handler);
      },

      unbind: function (el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  components: {
    VxAutoSuggest,
    VuePerfectScrollbar,
    draggable,
    SurveyPopup,
  },
};
</script>
